import { asset$ } from 'modules/asset/asset$';
import { combineLatest, map } from 'rxjs';
import crudStream from 'streams/crudStream/crudStream';
import { BaseCourse, Course } from 'types';
import { groupBy } from 'utils/dataUtils';
import { compare } from 'utils/sortUtils';

const [courseActions, courseRoutines, course$, courseState$] = crudStream<
  BaseCourse,
  Course
>('course', '/course');

export const courseViewModel$ = combineLatest([asset$, course$]).pipe(
  map(([{ byId }, courseState]) => {
    const visibleCourses = Object.values(courseState.byId).filter(e => e.published).sort(compare('createdAt'));
    return {
      byId: courseState.byId,
      visibleCourses,
      byTab: groupBy(Object.values(byId).filter(e => e.type === 'kurs'), 'tab')
    }
  }),
)

export { course$, courseActions, courseRoutines, courseState$ };
